(function () {
  function initHero(section) {
    var slides = section.querySelectorAll('.sl-hero__slide');
    var dots = section.querySelectorAll('.sl-hero__dot');
    var prev = section.querySelector('.sl-hero__arrow--prev');
    var next = section.querySelector('.sl-hero__arrow--next');
    if (!slides.length) return;

    var current = 0;
    var timer;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    function startAuto() {
      clearInterval(timer);
      timer = setInterval(function () { goTo(current + 1); }, 5000);
    }

    if (prev) prev.addEventListener('click', function () { goTo(current - 1); startAuto(); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); startAuto(); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); startAuto(); });
    });

    startAuto();
  }

  document.querySelectorAll('.sl-hero').forEach(initHero);
})();
